import './index.scss';
import React from 'react';
import {Box, Typography} from '@customink/pigment-react';

export default function QuoteErrorMessage({
  canOrderSingles,
  hasSingles,
  handleMiniQuantityError
}) {
  return (
    <Box>
      <Typography className="pc-Quote-Error-Message">
        This product has a minimum quantity of {canOrderSingles}.
      </Typography>
      {hasSingles && canOrderSingles === 6 && (
        <Typography className="pc-Quote-Error-Message">
          {' '}
          Please select a color{' '}
          <a onClick={handleMiniQuantityError}>available for small orders</a>
        </Typography>
      )}
    </Box>
  );
}
